import { Alert, Descriptions } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import ToolWrapper from './components/ToolWrapper';

/**
 * Renders the TransferToAgent tool response.
 * Shows agent transfer notification.
 */
function TransferToAgentTool({ item }) {
  const agentName = item.args?.agent_name || '';

  return (
    <Alert
      message={`Transferring to agent: ${agentName}`}
      type="info"
      showIcon
      style={{ margin: '8px 0' }}
    />
  );
}

TransferToAgentTool.propTypes = {
  item: PropTypes.shape({
    args: PropTypes.shape({
      agent_name: PropTypes.string,
    }),
  }).isRequired,
};

/**
 * Generic Tool Renderer (fallback).
 * Used when no specific renderer is available for a tool.
 */
function GenericTool({ item }) {
  const isPending = item.response === null || item.response === undefined;
  const hideResponse = item.name === 'analyze_segments';

  return (
    <ToolWrapper toolName={item.name} isPending={isPending}>
      <Descriptions column={1} bordered size="small">
        <Descriptions.Item label="Arguments">
          <pre style={{ margin: 0, fontSize: 12 }}>{JSON.stringify(item.args, null, 2)}</pre>
        </Descriptions.Item>
        {!isPending && !hideResponse && (
          <Descriptions.Item label="Response">
            <pre style={{ margin: 0, fontSize: 12 }}>{JSON.stringify(item.response, null, 2)}</pre>
          </Descriptions.Item>
        )}
      </Descriptions>
    </ToolWrapper>
  );
}

GenericTool.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    args: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
      ),
    ]),
    response: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
      ),
    ]),
  }).isRequired,
};

export { TransferToAgentTool, GenericTool };
